import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import GearEUService from "@services/GearEUService";

const ShowGearEU = ({ gearEU }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [gearEUData, setGearEUData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      GearEUService.find(gearEU.id).then((response) => {
        setGearEUData(response.data.data);
      });
  }, [gearEU.id, showModal]);

  return (
    <PermissionHandler permission={"view_gears_eu"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={gearEUData.name} />
          <RowDetails label={t("nameEng")} value={gearEUData.name_eng} />
          <RowDetails label={t("description")} value={gearEUData.description} />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowGearEU;
